import { useState } from 'react'

import { Alert, Box, Icon, Text, Touchable } from '@factorialco/deprecated-design-system'
import { LOCAL_STORAGE_KEYS } from 'config/Vars'
import { SignerStampItemFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

import DraggableStamp from 'modules/documents/components/EsignaturePlacementFile/DraggableStamp'
import OnboardingModal from 'modules/documents/components/EsignaturePlacementFile/OnboardingModal'
import { Stamp } from 'modules/documents/components/EsignaturePlacementFile/constants'

interface Props {
  signers: SignerStampItemFragment[]
  fileStamps: Stamp[]
  showValidations: boolean
}

const SignersSidebar = ({ signers, fileStamps, showValidations }: Props) => {
  const [hasSeenOnboardingModal, setHasSeenOnboardingModal] = useLocalStorage(
    LOCAL_STORAGE_KEYS.hideDocumentEsignaturePlacementHint,
    false
  )
  const [showOnboarding, setShowOnboarding] = useState(!hasSeenOnboardingModal)

  const onClose = () => {
    setHasSeenOnboardingModal(true)
    setShowOnboarding(false)
  }

  const onFinish = () => {
    setHasSeenOnboardingModal(true)
    setShowOnboarding(false)
  }

  const onShowOnboarding = () => {
    setShowOnboarding(true)
  }

  const pendingStamp = (signerId: number) =>
    fileStamps.every((stamp) => stamp.signer.id !== signerId)

  return (
    <>
      <Box width="s400" gap="s24" padding="s24">
        <Text.Normal weight="semibold">
          {i18n.t('documents.beta.form_modal.esignature_placement')}
        </Text.Normal>
        <Text size="200">{i18n.t('documents.beta.esignature_placement.description')}</Text>
        {signers.length > 0 && (
          <Box component="ul" gap="s12" borderRadius={{ all: 'abs004' }}>
            {signers.map((signer) => (
              <DraggableStamp
                key={signer.id}
                signer={signer}
                isPending={pendingStamp(signer.id)}
                isError={showValidations && pendingStamp(signer.id)}
                isSuccess={showValidations && !pendingStamp(signer.id)}
              />
            ))}
          </Box>
        )}
        <Alert color="info">
          <Box flexDirection="column" gap="s8">
            <Box flexDirection="row" gap="s4" alignItems="center">
              <Icon.Medium icon="lightbulb" color="viridian1000" />
              <Text size="200" weight="semibold">
                {i18n.t('documents.beta.esignature_placement.onboarding.info.title')}
              </Text>
            </Box>
            <Text size="200">
              {i18n.t('documents.beta.esignature_placement.onboarding.info.description')}
            </Text>
            <Touchable onClick={onShowOnboarding}>
              <Text size="100" weight="semibold" underlined>
                {i18n.t('documents.beta.esignature_placement.onboarding.info.show')}
              </Text>
            </Touchable>
          </Box>
        </Alert>
      </Box>
      {showOnboarding && <OnboardingModal onClose={onClose} onFinish={onFinish} />}
    </>
  )
}

export default SignersSidebar
